import React, { useState } from "react";
import {useActions} from "../../../hooks/useActions";

type Props = {
    isLoading: boolean;
    onSubmit:(e: React.FormEvent<HTMLFormElement>) => Promise<void>;
    onCancel: () => void;

};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const SignInForm: React.FC<Props> = ({
                                         isLoading,
                                         onSubmit,
                                         onCancel
                                     }) => {

    const {
        resetPassword,
        setSystemMessage
    } = useActions();

    const [forgotOpen, setForgotOpen] = useState(false);
    const [resetEmail, setResetEmail] = useState("");
    const [resetError, setResetError] = useState<string | null>(null);

    const handleForgotSend = async (e: React.FormEvent) => {
        if(isLoading) return;
        e.preventDefault();
        const email = resetEmail.trim();
        if (!emailRegex.test(email)) {
            setResetError("Please enter a valid email address.");
            return;
        }
        setResetError(null);
        try {
            await resetPassword(email);
            setForgotOpen(false);
        } catch (err: any) {
            setSystemMessage({
                isVisible: true,
                type: 'info',
                text: String(err),
                action: null
            });
            return;
        }
        setSystemMessage({
            isVisible: true,
            type: 'info',
            text: 'The email with your new password has been sent successfully.',
            action: null
        });
    };

    return (
        <>
            <form onSubmit={onSubmit} className="formSignIn">
                <label>
                    Email
                    <input type="email" name="email" autoComplete="email" required />
                </label>

                <label>
                    Password
                    <input
                        type="password"
                        name="password"
                        minLength={8}
                        autoComplete="current-password"
                        required
                    />
                </label>

                <div className="actionsSignIn">
                    <button type="button" className="btn ghost" onClick={onCancel}>
                        Cancel
                    </button>

                    <div
                        className="forgotPassword"
                        onClick={() => setForgotOpen(true)}
                    >
                        Forgot password
                    </div>

                    <div
                        role="button"
                        tabIndex={0}
                        className="signInButtonForm"
                        onClick={(e) => {
                            if (isLoading) return;
                            const form = (e.currentTarget.closest("form") as HTMLFormElement) || null;
                            form?.requestSubmit();
                        }}
                        onKeyDown={(e) => {
                            if (isLoading) return;
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                const form = (e.currentTarget.closest("form") as HTMLFormElement) || null;
                                form?.requestSubmit();
                            }
                        }}
                    />
                </div>
            </form>


            {forgotOpen && (
                <div
                    className="modal-backdrop"
                    onMouseDown={() => setForgotOpen(false)}
                    onKeyDown={(e) => e.key === "Escape" && setForgotOpen(false)}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="forgot-title"
                >
                    <div
                        className="modal-card"
                        onMouseDown={(e) => e.stopPropagation()} // prevent closing when clicking inside
                    >
                        <h2 id="forgot-title">Reset password</h2>

                       <div className={'resetPasswordTemporary'}>If you want reset password please write in Discord <br />
                           <a href="https://discord.gg/e5U3UnehP5" target="_blank">https://discord.gg/e5U3UnehP5</a>
                       </div>


                    </div>
                </div>
            )}

            {false && forgotOpen && (
                <div
                    className="modal-backdrop"
                    onMouseDown={() => setForgotOpen(false)}
                    onKeyDown={(e) => e.key === "Escape" && setForgotOpen(false)}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="forgot-title"
                >
                    <div
                        className="modal-card"
                        onMouseDown={(e) => e.stopPropagation()} // prevent closing when clicking inside
                    >
                        <h2 id="forgot-title">Reset password</h2>

                        <form onSubmit={handleForgotSend} className="formResetPassword">
                            <label htmlFor="resetEmail">Enter your email to reset your password</label>
                            <input
                                id="resetEmail"
                                type="email"
                                name="resetEmail"
                                placeholder="you@example.com"
                                value={resetEmail}
                                onChange={(e) => setResetEmail(e.target.value)}
                                required
                                autoComplete="email"
                                onMouseDown={(e) => e.stopPropagation()}
                            />

                            {resetError && <div className="errorText">{resetError}</div>}

                            <div className="actionsSignIn">
                                <button
                                    type="button"
                                    className="btn ghost"
                                    onClick={() => setForgotOpen(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn primary"
                                >
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default SignInForm;